import BasePointManager from "../../../../../../../src/managers/BasePointManager";
import { getRandomUniqueNumbers } from "../../../../../../../src/utils/generator/getRandomUniqueNumbers";
import { runShapeAnimation } from "../../CircleAnimationManager/CircleAnimationSequence";


export function generateRandomlyRadians(PointManager:BasePointManager, radians: number[]) {
  const newRadians = getRandomUniqueNumbers(4, 0, 11).map((v: number) => (v * (Math.PI / 6))).sort().reverse();
  runShapeAnimation(PointManager, radians, newRadians);
}